import { motion } from 'framer-motion';

const allItems = [
  { name: 'SOC 2', img: 'https://cdn.flynaut.com/images/SOC2_Flynaut .png', type: 'badge' },
  { name: 'ISO 27001', img: 'https://cdn.flynaut.com/images/flynaut_iso27001.webp', type: 'badge' },
  { name: 'Apple Developer', img: 'https://cdn.flynaut.com/images/Apple_Developer_Logo_White.png', type: 'logo' },
  { name: 'Microsoft Azure', img: 'https://cdn.flynaut.com/images/AzureLogo-1024x286.png', type: 'logo' },
  { name: 'Meta', img: 'https://cdn.flynaut.com/images/pngimg.com - meta_PNG7.png', type: 'logo' },
];

export default function AwardsPartners() {
  return (
    <section data-testid="awards-partners-section" className="relative bg-[#0a0e1a] py-16 lg:py-20 overflow-hidden">
      <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: 'linear-gradient(rgba(255,255,255,.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.1) 1px, transparent 1px)',
        backgroundSize: '60px 60px'
      }} />

      <div className="relative max-w-6xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-14"
        >
          <p className="text-xs font-semibold tracking-[0.25em] uppercase text-orange-400 mb-2">Trusted & Verified</p>
          <h2 className="text-2xl md:text-3xl font-bold text-white">Certifications & Partnerships</h2>
          <div className="mt-3 mx-auto w-16 h-0.5 bg-gradient-to-r from-orange-500 to-orange-300 rounded-full" />
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-6 md:gap-5 lg:gap-8 items-center justify-items-center">
          {allItems.map((item, i) => (
            <motion.div
              key={item.name}
              data-testid={`award-${item.name.toLowerCase().replace(/\s+/g, '-')}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.1 }}
              className="flex flex-col items-center gap-2 group cursor-default"
            >
              <div className={`flex items-center justify-center transition-transform duration-300 group-hover:scale-110 ${
                item.type === 'badge' 
                  ? 'w-16 h-16 md:w-20 md:h-20 lg:w-[88px] lg:h-[88px]' 
                  : 'w-24 h-10 md:w-28 md:h-14 lg:w-32 lg:h-16'
              }`}>
                <img
                  src={item.img}
                  alt={item.name}
                  className="max-w-full max-h-full object-contain"
                  loading="lazy"
                />
              </div>
              <span className="text-xs md:text-sm text-white/40 font-medium tracking-wide">{item.name}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
